import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { connect } from "react-redux";
import { changeStatus } from "../../../../store/actions";

const DialogAlert = ({ dialog, onClose, changeStatus, auth }) => {
  const onSubmit = () => {
    let data;

    if (dialog.type === "confirm") {
      data = {
        status: "accepted",
      };
    } else {
      data = {
        status: "rejected",
      };
    }

    if (auth.user.role_name === "hcis" && auth.user.sequence === 1) {
      changeStatus(dialog.value.id, dialog.type, data, true);
    } else {
      changeStatus(dialog.value.id, dialog.type, data);
    }
    onClose();
  };
  return (
    <div>
      <Dialog
        open={dialog.open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Apakah anda yakin?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Pastikan data perizinan sudah benar...
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="inherit" variant="contained">
            Cancel
          </Button>
          <Button onClick={onSubmit} color="primary" variant="contained">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps, { changeStatus })(DialogAlert);
